module.exports = __webpack_public_path__ + "static/media/crew-w-4.c4b08626.png";